import { render, staticRenderFns } from "./ChatBoxLocationDetail.vue?vue&type=template&id=39e91554&scoped=true"
import script from "./ChatBoxLocationDetail.vue?vue&type=script&lang=js"
export * from "./ChatBoxLocationDetail.vue?vue&type=script&lang=js"
import style0 from "./ChatBoxLocationDetail.vue?vue&type=style&index=0&id=39e91554&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e91554",
  null
  
)

export default component.exports